import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ResultsSection() {
  const results = ['Empresa correctamente estructurada desde el inicio', 'Preparación completa para apertura bancaria', 'Cumplimiento fiscal correcto', 'Documentación empresarial organizada profesionalmente', 'Estructura lista para Stripe y pasarelas de pago', 'Empresa operativa real, no solo registro', 'Base sólida para crecimiento empresarial', 'Operación legítima desde cualquier país'];
  return <section className="w-full bg-bg-section py-12 md:py-20 px-4" data-id="element-300">
      <div className="max-w-4xl mx-auto" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-302">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-303">
            Lo que lograrás con este sistema
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg p-5 md:p-8 mb-6 md:mb-8" data-id="element-304">
          <ul className="space-y-3 md:space-y-4" data-id="element-305">
            {results.map((result, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.05
          }} className="flex items-start" data-id="element-306">
                <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary mr-2 md:mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-307" />
                <span className="text-base md:text-lg text-text-primary" data-id="element-308">
                  {result}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center text-sm md:text-base text-text-secondary italic" data-id="element-309">
          Este ebook enseña estructura empresarial correcta. No promete ingresos
          ni resultados financieros.
        </motion.p>
      </div>
    </section>;
}